import { render, staticRenderFns } from "./FieldChoiceDetail.vue?vue&type=template&id=4d9358a4&scoped=true&"
import script from "./FieldChoiceDetail.vue?vue&type=script&lang=js&"
export * from "./FieldChoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./FieldChoiceDetail.vue?vue&type=style&index=0&id=4d9358a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9358a4",
  null
  
)

export default component.exports